import apiClient from '../index';

export const invitationApi = {
    // GET /api/guests/invitation — Invitation list
    getInvitationList: (params = {}) => apiClient.get('/guests/invitation', { params }),

    // POST /api/guests/search-by-card — Search invitation by card number
    searchByCard: (cardNumber) => apiClient.post('/guests/search-by-card', { card_number: cardNumber }),

    // GET /api/guests/invited — List invited guests
    getInvitedGuests: (params = {}) => apiClient.get('/guests/invited', { params }),

    // GET /api/guests/attendance — Attendance list
    getAttendanceList: (params = {}) => apiClient.get('/guests/attendance', { params }),

    // POST /api/guests/mark-attendance — Mark attendance
    markAttendance: (data) => apiClient.post('/guests/mark-attendance', data),

    // POST /api/guests/thank-note — Thank-note list
    getThankNoteList: (params = {}) => apiClient.get('/guests/thank-note', { params }),

    // GET /api/invitation-rsvp/{guestId} — Get RSVP details for a guest
    getInvitationRsvp: (guestId, params = {}) => {
        const id = guestId || params?.guest_id;
        const rawEventId = params?.event_id !== undefined ? params.event_id : params?.events_id;
        const eventId = rawEventId !== undefined && rawEventId !== null && rawEventId !== ''
            ? (Number(rawEventId) || rawEventId)
            : undefined;

        const queryParams = {
            ...(eventId !== undefined ? { event_id: eventId } : {}),
            guest_id: id ? String(id) : undefined,
            ...params
        };
        // Remove undefined keys
        Object.keys(queryParams).forEach(key => queryParams[key] === undefined && delete queryParams[key]);
        return apiClient.get(`/invitation-rsvp/${id}`, { params: queryParams });
    },

    // POST /api/invitation-rsvp — Record RSVP from invited guest (Public & Admin)
    recordRsvp: async (guestId, data = {}) => {
        const id = guestId || data?.guest_id;
        const rawEventId = data?.event_id !== undefined ? data.event_id : data?.events_id;
        const eventId = rawEventId !== undefined && rawEventId !== null && rawEventId !== ''
            ? (Number(rawEventId) || rawEventId)
            : undefined;

        const payload = {
            ...(eventId !== undefined ? { event_id: eventId } : {}),
            guest_id: id ? String(id) : undefined,
            rsvp: Number(data?.rsvp) || data?.rsvp || 1,
            submit: 'Hakiki',
            ...data
        };
        if (eventId !== undefined) payload.event_id = eventId;
        if (id) payload.guest_id = String(id);

        try {
            return await apiClient.post('/invitation-rsvp', payload);
        } catch (err) {
            // Fallback if live server expects path param or mark-attendance
            if (err?.response?.status === 405 || err?.response?.status === 404) {
                try {
                    return await apiClient.post(`/invitation-rsvp/${id}`, payload);
                } catch (fallbackErr) {
                    return await apiClient.post('/guests/mark-attendance', payload);
                }
            }
            throw err;
        }
    },

    // GET /api/export/invitations/{type} — Export invitations as a downloadable file
    exportInvitations: async (type = 'pdf', filename = 'invitations') => {
        const response = await apiClient.get(`/export/invitations/${type}`, {
            responseType: 'blob',
        });
        const blob = response instanceof Blob ? response : new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${type}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    },
};

export default invitationApi;
